export default __webpack_public_path__ + "static/media/Archpriest's Raiment of Sacrifice.a9b3b275.jpg";